var productSlider = new Swiper(".c-hp-product-slider", {
  slidesPerView: 1.3,
  spaceBetween: 10,
  breakpoints: {
    460: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    550: {
      slidesPerView: 2.2,
      spaceBetween: 10,
    },
    710: {
      slidesPerView: 3,
      spaceBetween: 5,
    },
    915: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
  },
  navigation: {
    nextEl: ".c-hp-product-slider .swiper-button-next",
    prevEl: ".c-hp-product-slider .swiper-button-prev",
  },
});

var influencerSectionid = new Swiper(
  "#influencerSection-id .influencerSectionSwiper",
  {
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
      410: {
        slidesPerView: 2,
      },
      500: {
        slidesPerView: 2,
      },
      724: {
        slidesPerView: 3,
      },
      940: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1216: {
        slidesPerView: 5,
      },
      1400: {
        slidesPerView: 6,
      },
    },
    navigation: {
      nextEl: "#influencerSection-id .swiper-button-next",
      prevEl: "#influencerSection-id .swiper-button-prev",
    },
  }
);

var homePageMobileAppV2Slider = new Swiper(
  ".c-hp-social-mobile-app .home-page-mobile-app-v2-slider",
  {
    loop: "true",
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",

    breakpoints: {
      0: {
        coverflowEffect: {
          rotate: 0,
          stretch: 150,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      340: {
        coverflowEffect: {
          rotate: 0,
          stretch: 190,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      420: {
        coverflowEffect: {
          rotate: 0,
          stretch: 220,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      767: {
        coverflowEffect: {
          rotate: 0,
          stretch: 320,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      1024: {
        coverflowEffect: {
          rotate: 0,
          stretch: 150,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      1200: {
        coverflowEffect: {
          rotate: 0,
          stretch: 200,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
      1400: {
        coverflowEffect: {
          rotate: 0,
          stretch: 250,
          depth: 700,
          modifier: 1,
          slideShadows: false,
        },
      },
    },
    navigation: {
      nextEl: ".c-hp-social-mobile-app .hp-mobile-app-v2-next",
      prevEl: ".c-hp-social-mobile-app .hp-mobile-app-v2-prev",
    },
  }
);

window.localStorage.removeItem("hpValues");

// c-hp-product-slider.liquid js codes below

const pcUnitCards = document.querySelectorAll(
  ".c-hp-product-default .pcUnitCard"
);

async function getData(url) {
  try {
    let res = await fetch(url);
    if (!res.ok) {
      // console.log("fetch failed");
      throw new Error("something went wrong :( ");
    }
    let data = res.json();
    // console.log(data)
    return data;
  } catch (err) {
    throw new Error(err);
  }
}

pcUnitCards.forEach((pcUnitCard) => {
  pcUnitCard.addEventListener("click", async (e) => {
    let parentEl = e.target.closest(".product-cart");
    let customSpinnerParent = parentEl.querySelector(".customSpinnerParent");
    let variantsParent = parentEl.querySelector(".product-card-variantsParent");
    let href = parentEl.querySelector(".redirectToPP").getAttribute("href");
    const { pHandle, fitmentsUrl } = pcUnitCard.dataset;

    /* No product for this card (or its page is gone) → All Fitments with the card's make + model */
    if (!pHandle) {
      if (fitmentsUrl) window.location.href = fitmentsUrl;
      return;
    }

    customSpinnerParent.style.display = "block";

    // Current market domain / locale (pedalcommander.de, /en/ …) — not a fixed .com URL
    let url = `${window.Shopify.routes.root}products/${pHandle}.js`;
    let data;
    try {
      const res = await fetch(url);
      if (res.status === 404 && fitmentsUrl) {
        window.location.href = fitmentsUrl;
        return;
      }
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      data = await res.json();
    } catch (err) {
      customSpinnerParent.style.display = "none";
      console.error("[c-hp-product-slider] could not load variants", pHandle, err);
      return;
    }
    if (data) {
      customSpinnerParent.style.display = "none";

      let variants = data.variants;
      variants.sort((a, b) => {
        if (variants.indexOf(a) < variants.indexOf(b)) return 1;
        else if (variants.indexOf(a) > variants.indexOf(b)) return -1;
        else return 0;
      });
      variantsParent.style.display =
        variantsParent.style.display === "flex" ? "none" : "flex";
      if (variants.length < 7) variantsParent.style.justifyContent = "center";
      variants.forEach((variant) => {
        const { id: variantID, title: variantTitle } = variant;
        let variantTitleArr = variantTitle.split(" / ");
        let variantPC = variantTitleArr[0];
        let variantYear = variantTitleArr[3];
        let variantEngine = variantTitleArr[4];
        variantEngine = variantEngine.replaceAll("-", " / ");
        //EXTRACTS "PC{digit}" from variant socket
        const variantPcCode = variantPC.match(/PC\d+/)?.[0];
        const isOutOfStock = window.outOfStockPcCodes?.includes(variantPcCode);
        // console.log(variantPcCode);
        // console.log(outOfStockSockets);
        // console.log(isOutOfStock);
        // const isOutOfStock = false;
        let li = document.createElement("li");
        if (isOutOfStock) li.classList.add("out-of-stock");
        li.innerHTML = `<button onclick="redirectPPFunc('${variantID}','${href}','${variantPC}','${variantYear}')" >
                            <span>${variantYear}</span>
                            <span class="variantEngine">${variantEngine}</span>
                            <span class="out-of-stock-indicator">OUT OF STOCK</span>
                      </button>`;
        variantsParent.appendChild(li);
      });
    }
  });
});

function redirectPPFunc(id, href, pc, year, make, model) {
  window.localStorage.setItem(
    "hpValues",
    JSON.stringify({ id, selection: `${pc} / ${year}` })
  );
  window.location.href = href;
}
